import apiClient from "../http-common";
//Unit Dropdown API
export const unitDropDown = async () => {
  return await apiClient.get(`/misc/unit`, {
    headers: {
      authorization:
        "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJNciBOaWxlc2ggU2hpbmRlIiwiZW1wSWQiOjY4LCJlbXBsb3llZVR5cGUiOiJIb3VzZWtlZXBpbmcgSW5jaGFyZ2UiLCJjcmVhdGVkIjoxNjkyNjc2NjU3Nzc2LCJleHAiOjI3NzI2NzY2NTcsInVzZXIiOjE1NCwic3RhdHVzIjp0cnVlLCJ1c2VybmFtZSI6Ik1yIE5pbGVzaCBTaGluZGUifQ.jgfQKryiLdGRm1cHZ8HzJo9fGST-0VRxFDoFzqc_n2gwb_SaE606BNURAAneU4aItK_7ZT0obrslPtFvxsBIMw",
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
};

export const blockDropDown = async (unitId) => {
  return await apiClient.get(`/misc/block/${unitId}`, {
    headers: {
      authorization:
        "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJNciBOaWxlc2ggU2hpbmRlIiwiZW1wSWQiOjY4LCJlbXBsb3llZVR5cGUiOiJIb3VzZWtlZXBpbmcgSW5jaGFyZ2UiLCJjcmVhdGVkIjoxNjkyNjc2NjU3Nzc2LCJleHAiOjI3NzI2NzY2NTcsInVzZXIiOjE1NCwic3RhdHVzIjp0cnVlLCJ1c2VybmFtZSI6Ik1yIE5pbGVzaCBTaGluZGUifQ.jgfQKryiLdGRm1cHZ8HzJo9fGST-0VRxFDoFzqc_n2gwb_SaE606BNURAAneU4aItK_7ZT0obrslPtFvxsBIMw",
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
};

export const genderDropDown = async () => {
  return await apiClient.get(`/misc/gender`, {
    headers: {
      authorization:
        "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJNciBOaWxlc2ggU2hpbmRlIiwiZW1wSWQiOjY4LCJlbXBsb3llZVR5cGUiOiJIb3VzZWtlZXBpbmcgSW5jaGFyZ2UiLCJjcmVhdGVkIjoxNjkyNjc2NjU3Nzc2LCJleHAiOjI3NzI2NzY2NTcsInVzZXIiOjE1NCwic3RhdHVzIjp0cnVlLCJ1c2VybmFtZSI6Ik1yIE5pbGVzaCBTaGluZGUifQ.jgfQKryiLdGRm1cHZ8HzJo9fGST-0VRxFDoFzqc_n2gwb_SaE606BNURAAneU4aItK_7ZT0obrslPtFvxsBIMw",
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
};

export const tariffDropDown = async () => {
  return await apiClient.get(`/misc/tariff`, {
    headers: {
      authorization:
        "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJNciBOaWxlc2ggU2hpbmRlIiwiZW1wSWQiOjY4LCJlbXBsb3llZVR5cGUiOiJIb3VzZWtlZXBpbmcgSW5jaGFyZ2UiLCJjcmVhdGVkIjoxNjkyNjc2NjU3Nzc2LCJleHAiOjI3NzI2NzY2NTcsInVzZXIiOjE1NCwic3RhdHVzIjp0cnVlLCJ1c2VybmFtZSI6Ik1yIE5pbGVzaCBTaGluZGUifQ.jgfQKryiLdGRm1cHZ8HzJo9fGST-0VRxFDoFzqc_n2gwb_SaE606BNURAAneU4aItK_7ZT0obrslPtFvxsBIMw",
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
};

export const storeDropDown = async () => {
  return await apiClient.get(`/misc/stores`, {
    headers: {
      authorization:
        "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJNciBOaWxlc2ggU2hpbmRlIiwiZW1wSWQiOjY4LCJlbXBsb3llZVR5cGUiOiJIb3VzZWtlZXBpbmcgSW5jaGFyZ2UiLCJjcmVhdGVkIjoxNjkyNjc2NjU3Nzc2LCJleHAiOjI3NzI2NzY2NTcsInVzZXIiOjE1NCwic3RhdHVzIjp0cnVlLCJ1c2VybmFtZSI6Ik1yIE5pbGVzaCBTaGluZGUifQ.jgfQKryiLdGRm1cHZ8HzJo9fGST-0VRxFDoFzqc_n2gwb_SaE606BNURAAneU4aItK_7ZT0obrslPtFvxsBIMw",
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
};

export const patientCategoryDropdown = async () => {
  return await apiClient.get(`/misc/patientcategory`, {
    headers: {
      authorization:
        "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJNciBOaWxlc2ggU2hpbmRlIiwiZW1wSWQiOjY4LCJlbXBsb3llZVR5cGUiOiJIb3VzZWtlZXBpbmcgSW5jaGFyZ2UiLCJjcmVhdGVkIjoxNjkyNjc2NjU3Nzc2LCJleHAiOjI3NzI2NzY2NTcsInVzZXIiOjE1NCwic3RhdHVzIjp0cnVlLCJ1c2VybmFtZSI6Ik1yIE5pbGVzaCBTaGluZGUifQ.jgfQKryiLdGRm1cHZ8HzJo9fGST-0VRxFDoFzqc_n2gwb_SaE606BNURAAneU4aItK_7ZT0obrslPtFvxsBIMw",
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
};

export const departmentDropdown = (searchString) => {
  return apiClient.get(`/misc/department/${searchString}`, {
    headers: {
      authorization:
        "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJNciBOaWxlc2ggU2hpbmRlIiwiZW1wSWQiOjY4LCJlbXBsb3llZVR5cGUiOiJIb3VzZWtlZXBpbmcgSW5jaGFyZ2UiLCJjcmVhdGVkIjoxNjkyNjc2NjU3Nzc2LCJleHAiOjI3NzI2NzY2NTcsInVzZXIiOjE1NCwic3RhdHVzIjp0cnVlLCJ1c2VybmFtZSI6Ik1yIE5pbGVzaCBTaGluZGUifQ.jgfQKryiLdGRm1cHZ8HzJo9fGST-0VRxFDoFzqc_n2gwb_SaE606BNURAAneU4aItK_7ZT0obrslPtFvxsBIMw",
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
};

export const relationDropdown = () => {
  return apiClient.get(`/misc/relation`, {
    headers: {
      authorization:
        "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJNciBOaWxlc2ggU2hpbmRlIiwiZW1wSWQiOjY4LCJlbXBsb3llZVR5cGUiOiJIb3VzZWtlZXBpbmcgSW5jaGFyZ2UiLCJjcmVhdGVkIjoxNjkyNjc2NjU3Nzc2LCJleHAiOjI3NzI2NzY2NTcsInVzZXIiOjE1NCwic3RhdHVzIjp0cnVlLCJ1c2VybmFtZSI6Ik1yIE5pbGVzaCBTaGluZGUifQ.jgfQKryiLdGRm1cHZ8HzJo9fGST-0VRxFDoFzqc_n2gwb_SaE606BNURAAneU4aItK_7ZT0obrslPtFvxsBIMw",
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
};

export const occupationDropdown = () => {
  return apiClient.get(`/misc/occupation`, {
    headers: {
      authorization:
        "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJNciBOaWxlc2ggU2hpbmRlIiwiZW1wSWQiOjY4LCJlbXBsb3llZVR5cGUiOiJIb3VzZWtlZXBpbmcgSW5jaGFyZ2UiLCJjcmVhdGVkIjoxNjkyNjc2NjU3Nzc2LCJleHAiOjI3NzI2NzY2NTcsInVzZXIiOjE1NCwic3RhdHVzIjp0cnVlLCJ1c2VybmFtZSI6Ik1yIE5pbGVzaCBTaGluZGUifQ.jgfQKryiLdGRm1cHZ8HzJo9fGST-0VRxFDoFzqc_n2gwb_SaE606BNURAAneU4aItK_7ZT0obrslPtFvxsBIMw",
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
};

// export const serviceDropdown = (searchObj)=>{
//   return  apiClient.get(`/misc/occupation/${searchObj}`,{
//     headers: {
//       authorization:
//         "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJNciBOaWxlc2ggU2hpbmRlIiwiZW1wSWQiOjY4LCJlbXBsb3llZVR5cGUiOiJIb3VzZWtlZXBpbmcgSW5jaGFyZ2UiLCJjcmVhdGVkIjoxNjkyNjc2NjU3Nzc2LCJleHAiOjI3NzI2NzY2NTcsInVzZXIiOjE1NCwic3RhdHVzIjp0cnVlLCJ1c2VybmFtZSI6Ik1yIE5pbGVzaCBTaGluZGUifQ.jgfQKryiLdGRm1cHZ8HzJo9fGST-0VRxFDoFzqc_n2gwb_SaE606BNURAAneU4aItK_7ZT0obrslPtFvxsBIMw",
//       Accept: "application/json",
//       "Content-Type": "application/json",}
//   })
// }

// Autosearch API Unit
export const getUnitDropdown = (searchString) => {
  return apiClient.post(`/pathParamUnit/searchString/${searchString}`);
};

// Autosearch API Tariff
export const getTariffDropdown = (searchString) => {
  return apiClient.post(`/tariff/searching/${searchString}`);
};

// Autosearch API Patient Category
export const getPatientCategoryDropdown = (searchString) => {
  return apiClient.post(`/patientCategory/searching/${searchString}`);
};
